const OPENAI_WIDGET = 'oai_widget';
export const BELI_WIDGET = 'dp_beli_widget';
export default OPENAI_WIDGET;
